<template>
    <div>LOGGING OUT</div>
</template>

<script>
//    alert('hi');
    export default {
        name: 'Logout',
        created: function(){
//           alert('logout');
            this.$store.dispatch('logOut');
//            this.$router.go('/login');
        }
    }
</script>


// WEBPACK FOOTER //
// Logout.vue?6d3655d4